<div *ngIf="loading" fxFlex="" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!loading" class="about-us-page" [innerHTML]="pageContent"></div>

